import { render, staticRenderFns } from "./IcEdit.vue?vue&type=template&id=4eb49e9a&scoped=true"
import script from "./IcEdit.vue?vue&type=script&lang=js"
export * from "./IcEdit.vue?vue&type=script&lang=js"
import style0 from "./IcEdit.vue?vue&type=style&index=0&id=4eb49e9a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4eb49e9a",
  null
  
)

export default component.exports